import { toast, ToastOptions } from "react-toastify";

export const notify = (message: string, options: ToastOptions = {}) => {
  toast(message, options);
};

export const clearAll = toast.dismiss; 
